import request from './request'
import Vue from 'vue'

//登录
export function login(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/login',
    method: 'post',
    data
  })
}
//退出登录
export function logout(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/logout',
    method: 'get',
    params:data
  })
}
//获取阿里临时token
export function getOssToken(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/oss/getToken',
    method: 'post',
    data
  })
}

//上传图片
export function uploadImages(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/upload/images',
    method: 'post',
    data
  })
}
//删帖
export function delMyBbs(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/delMyBbs',
    method: 'post',
    data
  })
}

//验证码
export function sendSms(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/sendSms',
    method: 'post',
    data
  })
}
//忘记密码
export function forgotPassword(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/forgotPassword',
    method: 'post',
    data
  })
}
//获取个人信息
export function getInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/getInfo',
    method: 'get',
    params: data,
  })
}

//切换身份
export function setSwitchIdentity(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/switchIdentity',
    method: 'post',
    data
  })
}
//获取身份列表
export function getIdentity(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getIdentity',
    method: 'post',
    data
  })
}
//获取身份倒数第二级列表
export function getNotLabelTree(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getNotLabelTree',
    method: 'post',
    data
  })
}
//获取身份最后一级
export function getIdentityChildren(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getIdentityChildren',
    method: 'post',
    data
  })
}
//获取章节树
export function getChapter(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getChapter',
    method: 'post',
    data
  })
}
//错题导出pdf
export function questionDownload(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/download',
    method: 'post',
    responseType:'blob',
    data
  })
}
//获取章节题ID
export function getQuestionId(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getQuestionId',
    method: 'post',
    data
  })
}

//活动详情
export function activityInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/setting/activityInfo',
    method: 'get',
    params: data,
  })
}
//会员中心
export function getShopVip(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/shop/getShopVip',
    method: 'get',
    params: data,
  })
}
//题库筛选条件
export function questionSift(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/sift',
    method: 'get',
    params: data,
  })
}
//获取题列表
export function getQuestionList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getList',
    method: 'post',
    data
  })
}
//重做
export function redoAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/redoAnswer',
    method: 'post',
    data
  })
}
//答题重做根据题ID
export function redoAnswerByQuestion(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/redoAnswerByQuestion',
    method: 'post',
    data
  })
}

//获取答题记录
export function getUserAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getUserAnswer',
    method: 'post',
    data
  })
}
//题统计
export function questionStat(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/stat',
    method: 'get',
    params: data,
  })
}
//题提交
export function questionSubmit(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/answer',
    method: 'post',
    data
  })
}
//题统计数据
export function putStat(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/answer/putStat',
    method: 'post',
    data
  })
}
//题纠错
export function questionCorrection(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/correction',
    method: 'post',
    data
  })
}
//设置题标签
export function questionSetLabel(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/setLabel',
    method: 'post',
    data
  })
}
//获取题标签
export function questionGetLabel(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getLabel',
    method: 'post',
    data
  })
}
//题收藏
export function questionCollect(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/collect',
    method: 'post',
    data
  })
}
//删除题收藏
export function questionRemoveCollect(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/removeCollect',
    method: 'post',
    data
  })
}
//添加更新笔记
export function questionNote(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/note',
    method: 'post',
    data
  })
}
//获取本人相关笔记
export function questionGetOwnNote(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getOwnNote',
    method: 'post',
    data
  })
}
//清除笔记
export function questionRemoveNote(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/removeNote',
    method: 'post',
    data
  })
}
//获取评论
export function commentGetList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/getList',
    method: 'post',
    data
  })
}
//获取回复列表
export function commentGetReplyList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/getReplyList',
    method: 'post',
    data
  })
}
//新增更新评论
export function commentSave(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/save',
    method: 'post',
    data
  })
}
//删除评论
export function commentRemove(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/remove',
    method: 'post',
    data
  })
}
//评论点赞踩
export function commentPraise(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/praise',
    method: 'post',
    data
  })
}
//删除点赞
export function commentRemovePraise(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/removePraise',
    method: 'post',
    data
  })
}
//我的评论
export function commentGetMyList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/getMyList',
    method: 'post',
    data
  })
}
//获取指定用户评论
export function commentGetUserList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/getUserList',
    method: 'post',
    data
  })
}
//举报评论
export function commentAccusation(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/accusation',
    method: 'post',
    data
  })
}
//回复我的评论
export function commentReplyMyList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/comment/replyMyList',
    method: 'post',
    data
  })
}
//获取单个题
export function questionGetInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getInfo',
    method: 'post',
    data
  })
}
//发起支付
export function userAppPay(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/appPay',
    method: 'post',
    data
  })
}
//获取支付接口
export function orderResult(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/orderResult',
    method: 'get',
    params: data,
  })
}
//获取简答题接口
export function getMyAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getMyAnswer',
    method: 'post',
    data
  })
}
//保存简答题接口
export function saveMyAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/saveMyAnswer',
    method: 'post',
    data
  })
}
//删除简答题接口
export function delMyAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/delMyAnswer',
    method: 'post',
    data
  })
}
//获取人机列表
export function getAllHumanList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/humanMachine/getAllHumanList',
    method: 'post',
    data
  })
}
//人机提交答案
export function getAllHumanAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/humanMachine/answer',
    method: 'post',
    data
  })
}
//获取人机题历史记录
export function getAllHumanGetAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/humanMachine/getAnswer',
    method: 'post',
    data
  })
}
//自主组题筛选条件
export function autonomousSift(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/sift',
    method: 'post',
    data
  })
}
//自主组题生成题
export function autonomousGenerateQuestion(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/generateQuestion',
    method: 'post',
    data
  })
}

//自主组题提交答案
export function autonomousAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/answer',
    method: 'post',
    data
  })
}
//自主组题列表
export function autonomousList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/list',
    method: 'post',
    data
  })
}
//自主组题题及答案
export function autonomousGetInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/getInfo',
    method: 'post',
    data
  })
}
//自主组题重做
export function autonomousRedo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/redo',
    method: 'post',
    data
  })
}
//自主组题多选删除
export function autonomousDel(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/del',
    method: 'post',
    data
  })
}
//自主组题重命名
export function autonomousRename(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/autonomous/rename',
    method: 'post',
    data
  })
}
//每日一练题
export function dailyPracticeGetQuestions(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/dailyPractice/getQuestions',
    method: 'post',
    data
  })
}
//每日一练回顾
export function dailyPracticeGetUserAnswers(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/dailyPractice/getUserAnswers',
    method: 'post',
    data
  })
}
//每日一练提交答案
export function dailyPracticeAddPractice(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/dailyPractice/addPractice',
    method: 'post',
    data
  })
}
//每日一练获取排行
export function dailyPracticeGetRank(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/dailyPractice/getRank',
    method: 'post',
    data
  })
}
//获取模考分类
export function getExamList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/getExamList',
    method: 'post',
    data
  })
}
//获取更多模考
export function getMoreExam(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/getMoreExamPage',
    method: 'post',
    data
  })
}
//获取模考详情
export function getExamInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/getInfo',
    method: 'post',
    data
  })
}
//获取模考答题记录
export function getExamAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/getAnswer',
    method: 'post',
    data
  })
}
//我的已参加模考
export function getRankingExam(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/getRankingExam',
    method: 'post',
    data
  })
}
//我的未参加模考
export function getNoteRankingExam(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/getNoteRankingExam',
    method: 'post',
    data
  })
}
//模考提交答题记录
export function getMockExamAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/answer',
    method: 'post',
    data
  })
}
//模考报名
export function setExamEnroll(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/enroll',
    method: 'post',
    data
  })
}
//成绩报告
export function setExamReport(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/examReport',
    method: 'post',
    data
  })
}
//模考排名
export function setExamRanking(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/exam/getRanking',
    method: 'post',
    data
  })
}
//题单分类仅列表
export function getCategoryList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getCategoryList',
    method: 'post',
    data
  })
}
//获取更多题单分页
export function getMoreUnitPage(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getMoreUnitPage',
    method: 'post',
    data
  })
}
//获取题单章节
export function getUnitChapter(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getChapter',
    method: 'post',
    data
  })
}
//获取题单详情
export function getUnitInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getInfo',
    method: 'post',
    data
  })
}
//获取题单题
export function getUnitQuestion(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getQuestion',
    method: 'post',
    data
  })
}
//提交题单题
export function setUnitAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/answer',
    method: 'post',
    data
  })
}
//获取答题记录
export function getUnitUserAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getUserAnswer',
    method: 'post',
    data
  })
}
//清楚答题记录
export function getUnitRedoAnswer(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/redoAnswer',
    method: 'post',
    data
  })
}
//考点狂背错题章节
export function getUnitPointsError(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getPointsError',
    method: 'post',
    data
  })
}
//考点狂背错题
export function getPointsErrorQuestion(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getPointsErrorQuestion',
    method: 'post',
    data
  })
}
//考点狂背筛选条件
export function questionGetSift(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getSift',
    method: 'get',
    params: data,
  })
}
//考点狂背关联题获取
export function questionGetPointsQuestion(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getPointsQuestion',
    method: 'post',
    data
  })
}
//获取考点狂背关联题
export function getPointsRelationQuestion(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/unit/getPointsRelationQuestion',
    method: 'post',
    data
  })
}
//修改用户信息
export function updateUserInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/updateUserInfo',
    method: 'post',
    data
  })
}
//用户身份信息列表
export function getUserSelect(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/getUserSelect',
    method: 'post',
    data
  })
}
//修改用户手机号
export function changeUserMobile(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/changeMobile',
    method: 'post',
    data
  })
}
//发送邮箱验证码
export function sendEmailCode(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/sendEmailCode',
    method: 'post',
    data
  })
}
//设置修改密码
export function changePassword(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/changePassword',
    method: 'post',
    data
  })
}
//关注
export function addRelation(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/addRelation',
    method: 'post',
    data
  })
}
//取消关注
export function delRelation(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/delRelation',
    method: 'post',
    data
  })
}
//帖子点赞/收藏/踩
export function bbsAddRelation(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/bbsAddRelation',
    method: 'post',
    data
  })
}
//取消 帖子点赞/收藏/踩
export function bbsDelRelation(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/bbsDelRelation',
    method: 'post',
    data
  })
}
//投票
export function setVote(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/setVote',
    method: 'post',
    data
  })
}
//关注列表
export function getRelationList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/getRelationList',
    method: 'post',
    data
  })
}
//被关注列表
export function getFansList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/getFansList',
    method: 'post',
    data
  })
}
//我的订单
export function orderList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/orderList',
    method: 'get',
    params: data
  })
}
//意见反馈
export function feedBackPost(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/feedBackPost',
    method: 'post',
    data
  })
}
//搜索题
export function questionSearch(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/search',
    method: 'post',
    data
  })
}
//消息通知小红点
export function myMessageRed(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/messageRed',
    method: 'get',
    params: data
  })
}
//获取系统消息
export function getMessageList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/getMessageList',
    method: 'post',
    data
  })
}
//获取论坛栏目分类
export function getBbsCategoryTree(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/getBbsCategoryTree',
    method: 'post',
    data
  })
}
//论坛列表
export function getBbsList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/getBbsList',
    method: 'get',
    params: data
  })
}
//帖子详情
export function getBbsInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/getBbsInfo',
    method: 'get',
    params: data
  })
}
//投票信息
export function getVoteInfo(data) {
  return request({
    url: Vue.prototype.dataurl+'/api/bbs/getVoteInfo',
    method: 'get',
    params:data
  })
}
//发帖
export function postBbs(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/bbs/postBbs',
    method: 'post',
    data
  })
}
//地址列表
export function addressList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/addressList',
    method: 'get',
    params:data
  })
}
//地址详情
export function getAddress(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/getAddress',
    method: 'get',
    params:data
  })
}
//获取省市区
export function getArea(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/getArea',
    method: 'get',
    params:data
  })
}
//设为默认
export function setDefaultAddress(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/setDefaultAddress',
    method: 'post',
    data
  })
}
//删除地址
export function delAddress(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/delAddress',
    method: 'post',
    data
  })
}
//保存地址
export function saveAddress(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/saveAddress',
    method: 'post',
    data
  })
}
//获取商城分类
export function getShopCatetory(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/shop/shopCatetory',
    method: 'get',
    params:data
  })
}
//获取商城列表
export function getShopList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/shop/shopList',
    method: 'get',
    params:data
  })
}
//获取商品详情
export function getShopInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/shop/shopInfo',
    method: 'get',
    params:data
  })
}
//积分签到
export function signInThree(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/points/signInThree',
    method: 'post',
    data
  })
}
//积分签到列表
export function signInLogThree(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/points/signInLogThree',
    method: 'post',
    data
  })
}
//积分过期
export function getScoreExpire(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/getScoreExpire',
    method: 'get',
    params:data
  })
}

//积分分享
export function pointShare(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/points/getShare',
    method: 'post',
    data
  })
}
//积分申请
export function pointAsk(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/points/ask',
    method: 'post',
    data
  })
}

//积分任务
export function pointTask(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/points/task',
    method: 'post',
    data
  })
}
//积分兑换
export function exchangePoints(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/user/exchangePoints',
    method: 'post',
    data
  })
}
//积分变动日志
export function pointsLog(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/points/log',
    method: 'post',
    data
  })
}
//返现记录
export function inviteOrderList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/inviteOrderList',
    method: 'get',
    params:data
  })
}
//生成二维码
export function makeQRCode(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/makeQRCode',
    method: 'get',
    responseType:'blob',
    params:data
  })
}
//申请提现
export function createCashout(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/createCashout',
    method: 'post',
    data
  })
}
//提现记录
export function cashoutList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/cashoutList',
    method: 'get',
    params:data
  })
}

//被邀请信息
export function myMuSuperior(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/muSuperior',
    method: 'get',
    params:data
  })
}
//添加邀请信息
export function addInviteCode(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/addInviteCode',
    method: 'get',
    params:data
  })
}
//收款列表
export function paymentWayList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/paymentWayList',
    method: 'get',
    params:data
  })
}
//收款方式
export function savePaymentWay(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/savePaymentWay',
    method: 'post',
    data
  })
}
//删除收款方式
export function delPaymentWay(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/delPaymentWay',
    method: 'post',
    data
  })
}
//获取指定用户的对外信息
export function getRelationInfo(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/my/getRelationInfo',
    method: 'post',
    data
  })
}
//全部任务
export function getQuestionTask(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/task',
    method: 'post',
    data
  })
}
//我的任务
export function getQuestionUserTask(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getUserTask',
    method: 'post',
    data
  })
}
//接受任务
export function setTask(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/setTask',
    method: 'post',
    data
  })
}
//放弃已接任务
export function delUserTask(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/delUserTask',
    method: 'post',
    data
  })
}
//获取仅章节树
export function getOnlyChapter(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/getOnlyChapter',
    method: 'post',
    data
  })
}
//提交任务
export function setUserTask(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/question/setUserTask',
    method: 'post',
    data
  })
}
//我的优惠券
export function getUserCoupons(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/coupons/getUserCoupons',
    method: 'post',
    data
  })
}
//兑换优惠券
export function fulfillCoupons(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/coupons/fulfillCoupons',
    method: 'post',
    data
  })
}
//验证优惠券
export function checkCoupons(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/coupons/checkCoupons',
    method: 'post',
    data
  })
}
//转赠优惠券
export function giftCoupons(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/coupons/giftCoupons',
    method: 'post',
    data
  })
}
//aige  问答页面文案
export function aigcText(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/text',
    method: 'get',
    params:data
  })
}
//aige答疑标签列表
export function aigcGetTagList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/getTagList',
    method: 'get',
    params:data
  })
}
//aige答疑列表
export function aigcGetQuestionAsk(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/getQuestionAsk',
    method: 'get',
    params:data
  })
}
//aigc 答疑
export function aigcAsk(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/ask',
    method: 'post',
    data
  })
}
//修改aigc答疑标签名称
export function aigcUpdateTag(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/updateTag',
    method: 'post',
    data
  })
}
//删除aigc答疑记录
export function aigcDelTag(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/delTag',
    method: 'post',
    data
  })
}
//aigc答疑记录-单条
export function getAnswerList(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/getAnswerList',
    method: 'get',
    params:data
  })
}
//AIASK导出pdf
export function aigcDownloadPdf(data) {
  return request({
    url: Vue.prototype.dataurl + '/api/aigc/donwloadPdf',
    method: 'post',
    responseType:'blob',
    data
  })
}
